document.addEventListener("DOMContentLoaded", function () {
  function countUp(el) {
    var numbers = el.querySelectorAll("[data-countup-number]");
    var observerOptions = { root: null, rootMargin: "0px 0px", threshold: 0 };
    
    function countDecimals(val) {
        if (Math.floor(val) === val) return 0;
        return val.toString().split(".")[1]?.length || 0;
    }
    
    function formatNumber(val, decimals) {
        return val.toLocaleString("en-US", {
            minimumFractionDigits: decimals,
            maximumFractionDigits: decimals
        });
    }
    
    function easeOutQuint(x) {
        return 1 - Math.pow(1 - x, 5);
    }
    
    function iterateValue(el, end, decimals) {
        var start = 0;
        var duration = 2500;
        var startTimestamp = null;

        function step(timestamp) {
            if (!startTimestamp) startTimestamp = timestamp;
            var elapsedPercent = (timestamp - startTimestamp) / duration;
            var easedProgress = Math.min(easeOutQuint(elapsedPercent), 1);
            var interimNumber = Math.abs(easedProgress * (end - start) + start);
            el.innerHTML = formatNumber(interimNumber, decimals);
            if (easedProgress < 1) {
                window.requestAnimationFrame(step);
            }
        }
        
        window.requestAnimationFrame(step);
    }
    
    var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            var end = parseFloat(entry.target.dataset.countupNumber.replace(/,/g, ""));
            var decimals = countDecimals(end);
            if (entry.isIntersecting) {
                iterateValue(entry.target, end, decimals);
            }
        });
    }, observerOptions);
    
    if (numbers.length > 0) {
        numbers.forEach(function (el) {
            observer.observe(el);
        });
    }
}

// Attach instances
var dataModules = document.querySelectorAll('[data-module="countup"]');

dataModules.forEach(function (element) {
    countUp(element);
});
});